import type { BuildingType } from '@kaeliux/shared';

/**
 * Route of the dedicated screen a building owns, for DS-18's popover
 * secondary action ("Open Research Center" etc). Only buildings with a real
 * standalone screen are listed here — everything else is managed entirely
 * through the popover/zone list.
 *
 * `recyclingPlant` has had a `SURFACE_LAYOUT` position since DS-25, so its
 * `/recycling` screen is reachable from its own popover too, not just the
 * zone list's "List view" link.
 */
export const BUILDING_SCREEN_ROUTE: Partial<Record<BuildingType, string>> = {
    laboratory: '/sciences',
    shipyard: '/shipyard',
    techCenter: '/starport',
    tradeCenter: '/trade-center',
    recyclingPlant: '/recycling',
};
